var _path, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgRecurring = function SvgRecurring(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.636 79.758c8.434 31.474 40.786 50.153 72.26 41.72s50.153-40.786 41.72-72.26S79.83-.936 48.356 7.498c-10.295 2.758-19.42 8.147-26.652 15.458l-10.358-5.98a2 2 0 0 0-2.998 1.818L9.69 49.882a2 2 0 0 0 2.922 1.687l27.593-14.382a2 2 0 0 0 .076-3.505l-9.56-5.52a48.86 48.86 0 0 1 20.223-11.005c26.14-7.004 53.008 8.509 60.012 34.648s-8.508 53.009-34.648 60.013S23.3 103.31 16.296 77.17a5 5 0 0 0-9.66 2.588"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 30,
    x: 65.818,
    y: 58.318,
    rx: 4,
    transform: "rotate(135 69.818 73.318)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 29,
    x: 58,
    y: 39,
    rx: 4
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRecurring);
export default ForwardRef;